import { TTypeOfCreateVideoStudioModalWindow } from './createVideoStudioModalState/createVideoStudioModalContext';
import { ICreateVideoStudio } from 'types';

export enum CreateVideoStudioActionTypes {
	CHANGE_NAME = 'CHANGE_NAME',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeName {
	type: CreateVideoStudioActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface ISetDataForSubmit {
	type: CreateVideoStudioActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: ICreateVideoStudio | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateVideoStudioActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfCreateVideoStudioModalWindow;
	};
}

interface IResetSelectedControls {
	type: CreateVideoStudioActionTypes.RESET_FIELDS;
}

export type TCreateVideoStudioAction =
	| IChangeName
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IResetSelectedControls;
